module.exports = __webpack_public_path__ + "img/枢纽大使.1d4dc7ec.png";